export const LOGIN_URI = '/';
export const CONVERSATION_URI = '/conversation';
